module.exports = __webpack_public_path__ + "img/confirm.269a1b4d.svg";